export default {
    names: {
        hour: "hour",
        minute: "minute",
        day: "day",
    },
    objects: {
        offline_update: "Work offline",
        time: "Time",
        type_time: "Time format",
        button_save: "Save",
        period: "Update check period",
        address: "Server address for updates",
    },
    notification: {
        load_error: "Load error",
        incorrect_data: "Value cannot be 0",
        download_ok: "Request send",
        download_error: "Request error",
    },
}